import { logout, test } from "api/bridgeUser";
import hubLayout from 'styles/css/hubLayout.module.css';
import { useModal } from 'components/common/ModalLayout';

export function AppBridge() {
  const { showModal } = useModal();

  const testShowModal = () => {
    showModal('alert', 'logout 테스트 모달', {confirm: true, cancel: false},
      logout
    );
  }
  return (
    <div style={{display:'flex', flexDirection: 'column', gap: '1rem'}}>
      <br /><h1>고객앱 브릿지 테스트</h1><br />
      <button type="button" className={`${hubLayout.btn} ${hubLayout.large} ${hubLayout.pink}`} onClick={()=>testShowModal()} >test showModal logout</button>
      <button type="button" className={`${hubLayout.btn} ${hubLayout.large} ${hubLayout.pink}`} onClick={()=>test()} >test</button>
      <button type="button" className={`${hubLayout.btn} ${hubLayout.large} ${hubLayout.pink}`} onClick={()=>logout()} >logout</button>
      {/* <button type="button" className={`${hubLayout.btn} ${hubLayout.large} ${hubLayout.pink}`} onClick={()=>{
        const data = {
          mac: "90DA6A0418DE",
          ip: "106.254.225.82",
          port: "3234",
          id: "u40418de",
          password: "11qqaa..",
          regName: "실 장비 TEST",
          connectType: "DDNS",
          model: "FVA-04M81",
          hddStatus: true
        };
        sampleVideo(data.mac, data.ip, data.port, data.id, data.password, data.regName, data.connectType, data.model, data.hddStatus);
      }} >sampleVideo</button>
       */}
    </div>
  )
}